import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Form } from 'reactstrap';

import { LoadingSpinner } from 'twyne-new.ui';

import Alert from './ui/Alert';
import Anime from './ui/Anime';
import Box from './ui/Box';
import Button from './ui/Button';
import AuthForm from './ui/Form';
import FormGroup from './ui/FormGroup';
import Header from './ui/Header';
import Input from './ui/Input';
import KeepSigned from './ui/KeepSigned';
import Label from './ui/Label';
import Link from './ui/Link';
import LoadingIcon from './ui/LoadingIcon';
import Wrapper from './ui/Wrapper';

class LoginForm extends React.Component {
  state = {
    email: '',
    password: '',
    loading: false,
  };

  componentDidMount() {
    this.props.onChangeError(null)
  }

  handleChange(property) {
    return event => {
      this.setState({ [property]: event.target.value });
    };
  }

  Login = () => {
    const showError = typeof this.props.error === 'string';

    const handleSubmit = async event => {
      event.preventDefault();
      this.setState({ loading: true })
      this.props.onChangeError(null)
      await this.props.handleSubmit(this.state, 'login');
      this.setState({ loading: false })
    }

    return <Form onSubmit={handleSubmit}>
      <Anime>
        <Box>
          <Wrapper>
            <Header />
            <AuthForm>
              <FormGroup>
                <Label>
                  Email
                </Label>
                <Input
                  type="email"
                  value={this.state.email}
                  onChange={this.handleChange('email')}
                />
              </FormGroup>
              <FormGroup>
                <Label>
                  Password
                </Label>
                <Input
                  type="password"
                  value={this.state.password}
                  onChange={this.handleChange('password')}
                />
              </FormGroup>
              <KeepSigned />
              <Button type="submit" disabled={this.state.loading && !showError}>
                Sign In
                {this.state.loading && !showError ? <LoadingIcon /> : null}
              </Button>
              <Link to="/auth/forgot">
                Forgot password?
              </Link>
            </AuthForm>
          </Wrapper>
          <Alert color="danger" isOpen={showError}>{this.props.error}</Alert>
        </Box>
      </Anime>
    </Form>
  }

  VerifyLogin = ({ method }) => {
    const [loading, setLoading] = useState(false)
    const [loadingSubmit, setLoadingSubmit] = useState(false)
    const [timer, setTimer] = useState(null)
    const [time, setTime] = useState(null)
    const showError = typeof this.props.error === 'string';

    const handleTimer = () => {
      setTime(time => time || 60)
      timer && clearInterval(timer)
      const newTimer = setInterval(() => {
        setTime(time => {
          if (time > 0) return time - 1
          clearInterval(newTimer)
          return 0
        })
      }, 1000)
      setTimer(newTimer)
    }

    const handleResendCode = async () => {
      setLoading(true)
      await this.props.handleSubmit(this.state, 'login')
      setLoading(false)
      handleTimer()
    }

    const handleSubmit = event => {
      event?.preventDefault()
      timer && clearInterval(timer)
      setLoadingSubmit(true)
      this.props.handleSubmit(this.state, 'verifyLogin').finally(() => {
        setLoadingSubmit(false)
      })
    }

    useEffect(() => {
      handleTimer()
    }, [this.props.error])

    useEffect(() => {
      if (this.state.code?.length === 6) {
        handleSubmit()
      }
    }, [this.state.code])

    return <Form onSubmit={handleSubmit}>
      <Anime>
        <Box>
          <Wrapper>
            <Header />
            <AuthForm>
              <FormGroup>
                <Label>
                  Code
                </Label>
                <Input
                  type="number"
                  value={this.state.code}
                  onChange={this.handleChange('code')}
                />
              </FormGroup>
              <div className='flex flex-col gap-2'>
                <Button type="submit" disabled={loadingSubmit}>
                  Confirm
                  {loadingSubmit && <LoadingSpinner width={18} height={18} />}
                </Button>
                <Button link onClick={handleResendCode} disabled={time > 0 || loading}>
                  Resend Code {time ? <span className="text-lowercase">({time}s)</span> : null}
                </Button>
              </div>
            </AuthForm>
          </Wrapper>
          <Alert color="danger" isOpen={showError}>{this.props.error}</Alert>
          <Alert iconSize={30} color="success" isOpen={method && !showError && !loading}>{FEEDBACK[method]}</Alert>
        </Box>
      </Anime>
    </Form >
  }

  render() {
    const { twoFactorRequired, method } = this.props.data || {}

    if (twoFactorRequired) {
      return <this.VerifyLogin method={method} />
    }

    return <this.Login />
  }
}

const FEEDBACK = {
  email: 'The verification code has been sent, check your e-mail inbox and enter the 6-digit code.',
  authenticator: 'Verification code required, check your authenticator app and enter the 6-digit code valid.',
}

LoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  error: PropTypes.string,
  twoFactorRequired: PropTypes.bool,
};

export default LoginForm;
